<template>
  <div>
    <!-- No content -->
  </div>
</template>

<script>
export default {
  name: "BooleanAvaliationItemStrategy",
}
</script>
